<template>
  <div>
    <el-skeleton :loading="loading" animated>
      <template slot="template">
        <header class="site-header">
          <div class="header-area">
            <div class="wrap">
              <div class="header-top">
                <h1 class="logo"><a href="/usr/main" aria-current="page" class="router-link-exact-active router-link-active">KHFF 건강기능식품교육센터</a></h1>
              </div>
            </div>
          </div>
          <div class="util">
            <div class="wrap">
              <a class="btn spot3" v-if="!isMobile()">
                <i class="ico-remote wh"></i>
                원격지원
              </a>
              <router-link to="/usr/login" class="btn spot">
                <i class="ico-unrock wh"></i>
                로그인
              </router-link>
              <router-link to="/usr/signup/term" class="btn spot2">
                <i class="ico-join wh"></i>
                회원가입
              </router-link>
            </div>
          </div>
        </header>
        <div>
          <el-skeleton-item style="height: 5vh; margin-top: 5px" />
          <el-skeleton-item style="height: 30vh" />
          <el-skeleton-item style="height: 7vh" />
          <el-skeleton-item style="width: 49vw; height: 20vh; float: left" />
          <el-skeleton-item style="width: 49vw; height: 20vh; float: right" />
          <el-skeleton-item style="height: 7vh; margin-top: 10px" />
        </div>
      </template>
      <template>
        <header class="site-header">
          <SiteHeader ref="siteHeader"></SiteHeader>
          <div class="util">
            <div class="wrap" v-if="currentUser?.isAuthenticated">
              <span>
                <u>{{ currentUser.userNm }}</u>
                님 접속중
              </span>
              <a href="https://helpu.kr/khff" target="_blank" class="btn spot3" v-if="!isMobile()">
                <i class="ico-remote wh"></i>
                원격지원
              </a>
              <a @click="setLogout" class="btn spot">
                <i class="ico-unrock wh"></i>
                로그아웃
              </a>
            </div>
            <div class="wrap" v-if="!currentUser?.isAuthenticated">
              <a href="https://helpu.kr/khff" target="_blank" class="btn spot3" v-if="!isMobile()">
                <i class="ico-remote wh"></i>
                원격지원
              </a>
              <router-link to="/usr/login" class="btn spot">
                <i class="ico-unrock wh"></i>
                로그인
              </router-link>
              <router-link to="/usr/signup/term" class="btn spot2">
                <i class="ico-join wh"></i>
                회원가입
              </router-link>
            </div>
          </div>
        </header>

        <div class="site-body">
          <div class="sub-top" v-if="$route.meta.layout != null && $route.meta.layout.name != 'MainLayout'">
            <div class="wrap">
              <h2 v-if="menuMap != null">{{ menuMap.text }}</h2>
              <ul class="location">
                <li>
                  <router-link to="/usr/main" class="home">홈</router-link>
                </li>
                <li v-if="locMenuList.length > 0" v-for="item in locMenuList" :key="item.id">
                  <a @click="goMenu(item)">{{ item.text }}</a>
                </li>
              </ul>
              <ul class="lnb">
                <li v-if="subMenuList.length > 0" v-for="item in subMenuList" :key="item.id">
                  <a @click="goMenu(item)" :class="item.id == parseInt(menuMap.id) ? 'is-active' : ''">{{ item.text }}</a>
                </li>
              </ul>
            </div>
          </div>

          <component :is="$route.meta.layout || 'MainLayout'">
            <router-view />
          </component>
        </div>

        <footer class="site-footer" v-if="!isApp()">
          <SiteFooter></SiteFooter>
        </footer>
      </template>
    </el-skeleton>
  </div>
</template>

<style>
a:hover {
  cursor: pointer;
}
</style>
<script>
import { apiURL, siteURL } from "@/utils";
import { mapGetters } from "vuex";
import "@/static/css/element-ui.css";
import SiteHeader from "@/layout/SiteHeader";
import SiteFooter from "@/layout/SiteFooter";
import MainLayout from "@/layout/MainLayout";
import SubLayout from "@/layout/SubLayout";
import router from "@/router";
import { defualtMeta } from "@/utils/meta";

export default {
  name: "App",
  components: {
    SiteHeader,
    SiteFooter,
    MainLayout,
    SubLayout,
    router,
  },
  data() {
    return {
      menuId: 0,
      menuList: [],
      loading: true,
      menuMap: {},
      subMenuList: [],
      locMenuList: [],
      currentMenuId: 0,
      parentMenuId: 0,
      isMobileApp: false,
    };
  },
  metaInfo: {
    titleTemplate: (titleChunk) => {
      return titleChunk != "건강기능식품&수입식품 온라인 위생교육기관" ? `${titleChunk} - 건강기능식품&수입식품 온라인 위생교육기관` : titleChunk;
    },
    link: [{ rel: "canonical", href: "edu.khff.or.kr" }],
    meta: defualtMeta,
  },
  created() {
    if (process.env.NODE_ENV === "development") {
      const el = document.querySelector("meta[name=viewport]");
      if (el !== null) {
        let content = el.getAttribute("content");
        let re = /maximum\-scale=[0-9\.]+/g;
        if (re.test(content)) {
          content = content.replace(re, "maximum-scale=1.0");
        } else {
          content = [content, "maximum-scale=1.0"].join(", ");
        }
        el.setAttribute("content", content);
      }

      this.loadJs(siteURL + "/assets/js/user/jquery-ui.min.js");
      this.loadJs(siteURL + "/assets/js/user/jquery.easing.1.3.js");
      this.loadJs(siteURL + "/assets/js/user/ssm.min.js");
      this.loadJs(siteURL + "/assets/js/user/slick.js");
      this.loadJs(siteURL + "/assets/js/user/TweenMax.min.js");
      this.loadJs(siteURL + "/assets/js/user/ScrollMagic.min.js");
      this.loadJs(siteURL + "/assets/js/user/animation.gsap.min.js");
      this.loadJs(siteURL + "/assets/js/user/common2022.js");
      this.loadCss(siteURL + "/assets/css/user/style2022.css");
    }
  },
  mounted() {
    this.checkSession();
    this.getMenuList();

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        // console.log("bye");
      } else {
        // console.log("welcome");
        //this.$store.dispatch("getCheckSession").then(() => {});
      }
    });

    var self = this;
    window.addEventListener("focus", (event) => {
      // console.log(`Event: ${event.type}`);
      if (this.currentUser == null || this.currentUser.userId == null) return;
      self.$store.dispatch("getCheckSession").then(() => {});
    });
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser", "currentMenu"]),
  },
  watch: {
    $route: function (to, from) {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
      this.currentMenuId = localStorage.getItem("MENU");
      this.getMenuInfo();
    },
    currentMenu: {
      immediate: true,
      handler(value) {
        localStorage.setItem("FMENU", value);
        this.getMenuInfo();
      },
    },
  },
  methods: {
    checkSession() {
      if (this.currentUser == null || this.currentUser.userId == null) return;
      this.$nextTick(() => {
        this.$store.dispatch("getCheckSession").then(() => {});
      });
    },
    setRetriveSession() {
      this.$store.dispatch("setSessionRetrive", {});
    },
    setLogout() {
      this.$store.dispatch("setLogout", this.resultMap).then(() => {
        this.$nextTick(() => {
          this.$router.push({ path: "/usr/main" }).catch(() => {});
        });
      });
    },
    goMenu(item) {
      localStorage.setItem("MENU", item.id);
      this.$router.push(item.url).catch(() => {});
    },
    getMenuList() {
      this.loading = true;
      return this.request(`${apiURL}/menu/header`).then((result) => {
        if (result.headers["isauthenticated"] && result.config.headers["X-Auth-Token"] == null) {
          // 실제 세션은 살아 있지만, currentUser가 비어 있을 경우 다시 세션 정보 가져오기
          this.setRetriveSession();
        }

        var data = result.data;
        this.setMenuUrlChange(data.menuList.children);

        data.menuList.children.push({
          text: "로그인",
          url: "/usr/login",
          id: 980,
          parentId: 99,
          path: "/980",
          type: "folder",
          order: 1,
          level: 2,
        });
        data.menuList.children.push({
          text: "아이디/비밀번호찾기",
          url: "/usr/login/find",
          id: 981,
          parentId: 99,
          path: "/981",
          type: "folder",
          order: 2,
          level: 2,
        });
        data.menuList.children.push({
          text: "회원가입",
          url: "/usr/signup/term",
          id: 982,
          parentId: 99,
          path: "/982",
          type: "folder",
          order: 3,
          level: 2,
        });

        data.menuList.children.push({
          text: "이용안내",
          url: "/usr/intro/legal",
          id: 983,
          parentId: 98,
          path: "/983",
          type: "folder",
          order: 3,
          level: 2,
        });
        data.menuList.children.push({
          text: "개인정보처리방침 ",
          url: "/usr/intro/privacy",
          id: 984,
          parentId: 98,
          path: "/984",
          type: "folder",
          order: 3,
          level: 2,
        });
        data.menuList.children.push({
          text: "이메일 무단수집 거부",
          url: "/usr/intro/emailprivacy",
          id: 985,
          parentId: 98,
          path: "/985",
          type: "folder",
          order: 3,
          level: 2,
        });

        this.menuList = data.menuList || [];

        this.getMenuInfo();
        this.loading = false;

        this.$nextTick(() => {
          this.$refs.siteHeader.setMenuList(data.menuList);
        });
      });
    },
    setMenuUrlChange(data) {
      data.map((item) => {
        if (item.id == "211") item.url = `/usr/crse`;
        if (item.id == "2112") item.url = `/usr/crse/1003`;
        if (item.id == "212") item.url = `/usr/enroll/intro/1005`;
        if (item.id == "213") item.url = `/usr/myclass`;
        if (item.id == "327") item.url = `/usr/enroll/search`;
        if (item.id == "215") item.url = `/usr/bbs/10005`;
        if (item.id == "216") item.url = `/usr/mypage`;

        if (item.id == "217") item.url = `/usr/crse/1003`;
        if (item.id == "337") item.url = `/usr/crse/1006`;
        if (item.id == "374") item.url = `/usr/crse/law`;

        if (item.id == "222") item.url = `/usr/enroll/intro/1005`;
        if (item.id == "223") item.url = `/usr/enroll/intro/1006`;

        if (item.id == "225") item.url = `/usr/myclass`;
        if (item.id == "368") item.url = `/usr/mypage`;

        if (item.id == "370") item.url = `/usr/myclass/cert`;
        if (item.id == "372") item.url = `/usr/myclass/agent`;

        if (item.id == "373") item.url = `/usr/enroll/search`;

        if (item.id == "232") item.url = `/usr/bbs/10005`;
        if (item.id == "345") item.url = `/usr/bbs/10030`;
        if (item.id == "234") item.url = `/usr/bbs/10007`;
        if (item.id == "233") item.url = `/usr/bbs/faq/10006`;
        if (item.id == "235") item.url = `/usr/bbs/10008`;

        if (item.id == "237") item.url = `/usr/mypage/info`;

        if (item.children != null) {
          this.setMenuUrlChange(item.children);
        }
      });
    },
    getMenuInfo() {
      if (this.menuList.children != null) {
        this.getMenu();
        this.getSubMenu();
      }
    },
    getSubMenu() {
      this.subMenuList = [];
      if (this.menuMap != null) {
        this.getFindChildMenu(this.menuList.children, this.menuMap.parentId, this.subMenuList);
      }
    },
    getMenu() {
      this.menuMap = {};
      this.locMenuList = [];

      // console.log("FMENU", localStorage.getItem("FMENU"));
      if (localStorage.getItem("FMENU") != null && localStorage.getItem("FMENU") != "null") {
        // console.log("FMENU", localStorage.getItem("FMENU"));
        this.menuMap = this.getFindMenu(this.menuList.children, "id", localStorage.getItem("FMENU"));

        this.$store.dispatch("removeCurrentMenu");
      } else {
        this.menuMap = this.getFindMenu(this.menuList.children, "path", this.$route.path);
        if (this.menuMap == null) {
          this.menuMap = this.getFindMenu(this.menuList.children, "id", localStorage.getItem("MENU"));
        }
      }

      if (this.menuMap == null) {
        return;
      }

      localStorage.setItem("MENU", this.menuMap.id);

      if (this.menuMap != null && this.menuMap.path != null) {
        var menuPath = this.menuMap.path.split("/");
        menuPath.map((item) => {
          if (item != null && item != "") {
            var locMenu = this.getFindMenu(this.menuList.children, "id", item);
            if (locMenu != null) this.locMenuList.push(locMenu);
          }
        });
      }
    },
    getFindMenu(menu, type, compareId) {
      var menuInfo = null;
      findMenu(menu, type, compareId);

      return menuInfo;

      function findMenu(menu, type, compareId) {
        menu.map((item) => {
          if (type == "id" && parseInt(item.id) == parseInt(compareId)) {
            menuInfo = item;
          }
          if (type == "path" && item.url == compareId && item.level > 1) {
            menuInfo = item;
          }

          if (item.children != null) {
            findMenu(item.children, type, compareId);
          }
        });
      }
    },
    getFindChildMenu(menu, compareId, list) {
      menu.map((item) => {
        if (item.parentId == parseInt(compareId) && item.level != 1) {
          list.push(item);
        }

        if (item.children != null) {
          this.getFindChildMenu(item.children, compareId, list);
        }
      });
    },
    loadCss: function (url) {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = url;
      document.head.appendChild(file);
    },
    loadJs: function (url) {
      let file = document.createElement("script");
      file.setAttribute("src", url);
      file.async = true;
      document.head.appendChild(file);
    },
  },
};
</script>
